// Widgets-Homescreen der Pille – reine Ableitungen für die großen Widgets (Handoff Pille §5, Screen 12/21).
import { stundenText } from '../zeiterfassung/berechnung';

export interface ZeitRing {
  /** Füllgrad des Rings 0…1 */
  anteil: number;
  prozentText: string;
  /** „noch 3:12 h“ bzw. „Soll erreicht“ */
  restText: string;
}

/** Ring des Zeit-Widgets: heutige Ist-Minuten gegen das Tagessoll. */
export function zeitRing(heuteMinuten: number, sollMinuten: number): ZeitRing {
  const anteil = sollMinuten > 0 ? Math.min(1, Math.max(0, heuteMinuten / sollMinuten)) : heuteMinuten > 0 ? 1 : 0;
  return {
    anteil,
    prozentText: `${Math.round(anteil * 100)} %`,
    restText: heuteMinuten >= sollMinuten ? 'Soll erreicht' : `noch ${stundenText(sollMinuten - heuteMinuten)}`,
  };
}

/** Gespräch fürs Chat-Widget: das erste mit Ungelesenem, sonst das jüngste mit Nachricht. */
export function chatFuerWidget<T extends { ungelesen: number; letzte: unknown }>(unterhaltungen: readonly T[]): T | null {
  return unterhaltungen.find(u => u.ungelesen > 0 && u.letzte) ?? unterhaltungen.find(u => u.letzte) ?? null;
}
